export default __webpack_public_path__ + "static/media/bloodlevel@3x.356c193a.jpg";